<template>
  <div>
    <div>
      <el-button type="text" @click="goback" size="mini" class="mb-2" icon="el-icon-arrow-left">列表</el-button>
    </div>
    <el-tree
        class="filter-tree"
        :data="cataLog"
        default-expand-all
        @node-click="handleNodeClick"
        node-key="routeName"
        highlight-current
        :current-node-key="$route.name"
        ref="tree">
    </el-tree>
  </div>
</template>

<script>
export default {
  name: "CmaCatalog",
  props: ['siteType', 'projectId', 'siteId', 'rrType', 'title', 'routeName'],
  data() {
    return {
      cateGroup: {
        czw: ['index', 'gcgk', 'jczs', 'hw311', 'hw321', 'jddz', 'sydl', 'jl',], // 出租屋
        sx: ['index', 'gcgk', 'jczs', 'hw311', 'hw321', 'sydl', 'jl',], // 三小
        other: ['index', 'gcgk', 'jczs', 'hw311', 'hw321', 'jddz', 'sydl', 'jydz', 'jl',], // 其他
      }
    }
  },
  computed: {
    cateAll() {
      return [
        {id: 1, key: 'index', label: '首页', routeName: this.rrType + '_cma_index',},
        {id: 2, key: 'gcgk', label: '工程概况', routeName: this.rrType + '_cma_gcgk',},
        {id: 3, key: 'jczs', label: '检测综述', routeName: this.rrType + '_cma_jczs',},
        {id: 4, key: 'hw311', label: '红外诊断1', routeName: this.rrType + '_cma_hw311',},
        {id: 5, key: 'hw321', label: '红外诊断2', routeName: this.rrType + '_cma_hw321',},
        {id: 6, key: 'jddz', label: '接地电阻', routeName: this.rrType + '_cma_jddz',},
        {id: 7, key: 'sydl', label: '剩余电流', routeName: this.rrType + '_cma_sydl',},
        {id: 8, key: 'jydz', label: '绝缘电阻', routeName: this.rrType + '_cma_jydz',},
        {id: 9, key: 'jl', label: '电气系统距离', routeName: this.rrType + '_cma_jl',},
      ]
    },
    cataLog() {
      return this.cateAll.filter(v => this.cateGroup[this.siteType].includes(v.key)); // 这里也可以改为id
    },
    route() {
      return [{name: this.title}]
    }
  },
  methods: {
    handleNodeClick(data) {
      if (this.$route.name != data.routeName) {
        this.$router.push({
          name: data.routeName,
          params: {
            project_id: this.projectId,
            site_id: this.siteId,
            site_type: this.siteType
          }
        })
      }
    },
    goback() {
      this.$router.push({name: this.routeName, params: this.$route.params})
    },
  }
}
</script>
<style lang="scss" scoped>
.mb-2 {
  margin-bottom: 10px;
}
.filter-tree {
  margin-right: 10px;
}

::v-deep .el-tree-node__content {
  padding: 10px 0;
}
</style>
